export default __webpack_public_path__ + "static/media/single-project-page-03-img10.3c45ee0f.jpg";